const validName = (name) => {
  const noSpecialCharacters = new RegExp(/^[A-Za-z0-9àáâäãåąč&ćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽð]+$/g);
  if (name) {
    const isValid = noSpecialCharacters.test(name);
    return isValid;
  }
};

module.exports = {
  validName,
};
